import { useAuth } from '@/contexts/AuthContext';

export function useRolePermissions() {
  const { user } = useAuth();

  const isSecretary =
    user?.role === 'secretary';

  const canManageLegalStructures =
    user?.role === 'admin' ||
    user?.role === 'lawyer';

  return {
    isSecretary,
    canManageLegalStructures,
  };
}
